"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Tab_1 = require("@mui/material/Tab");
var Tabs_1 = require("@mui/material/Tabs");
var styles_1 = require("@mui/material/styles");
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, hidePaper = props.hidePaper, other = __rest(props, ["children", "value", "index", "hidePaper"]);
    if (hidePaper) {
        return (react_1.default.createElement("div", __assign({ role: "tabpanel", hidden: value !== index, id: "vertical-tabpanel-".concat(index), "aria-labelledby": "vertical-tab-".concat(index) }, other), value === index && children));
    }
    return (react_1.default.createElement(material_1.Paper, __assign({ role: "tabpanel", hidden: value !== index, id: "vertical-tabpanel-".concat(index), "aria-labelledby": "vertical-tab-".concat(index) }, other), value === index && (react_1.default.createElement(material_1.Box, { p: 6, overflow: "auto", minHeight: "calc(100vh - 500px)", maxWidth: "70em", margin: "0 auto" }, children))));
}
var StyledTabs = (0, styles_1.styled)(material_1.Tabs)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(Tab_1.tabClasses.root)] = {
            alignItems: 'flex-start',
            fontSize: '1em',
            textTransform: 'capitalize',
            textAlign: 'left',
            // todo inject a gray from theme
            color: 'rgba(0,0,0, 0.75)',
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1),
            paddingRight: theme.spacing(4),
            opacity: '0.9',
            maxWidth: 'none'
        },
        _b[Tabs_1.tabsClasses.root] = {
            borderRight: 1,
            borderColor: 'divider',
            height: '100%',
            opacity: '0.9',
        },
        _b[".".concat(Tab_1.tabClasses.selected)] = {
            backgroundColor: theme.palette.action.selected,
            color: theme.palette.grey[800],
        },
        _b[".".concat(Tabs_1.tabsClasses.indicator)] = {
            opacity: '0.4',
            content: "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' fill='red' stroke='currentColor' class='bi bi-chevron-right' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");",
            background: 'none',
            marginRight: theme.spacing(1)
        },
        _b);
});
var VerticalTabDetailPanel = function (props) {
    var _a = react_1.default.useState(0), tabvalue = _a[0], setTabValue = _a[1];
    var handleChangeTab = function (event, newValue) {
        setTabValue(newValue);
    };
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sm: 4, lg: 3 },
            react_1.default.createElement(material_1.Paper, { sx: { height: '100%' } },
                react_1.default.createElement(material_1.Box, { py: 5, px: 4 },
                    react_1.default.createElement(StyledTabs, { orientation: "vertical", variant: "scrollable", value: tabvalue, onChange: handleChangeTab, textColor: "inherit", TabIndicatorProps: { sx: { height: '16px', width: '16px' } } }, props.tabs.map(function (tab) { return (tab.tabComponent); }))))),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sm: 8, lg: 9 }, props.tabs.map(function (tab, iter) { return (react_1.default.createElement(TabPanel, { index: iter, value: tabvalue, key: "vtpanel-".concat(iter), hidePaper: tab.hidePaper }, tab.panelComponent)); }))));
};
exports.default = VerticalTabDetailPanel;
